export const RoutesLink = {
  login: "/",
  forgot_password: "/forget-password",
  verify_otp: "/verify-otp",
  new_password: "/new-password",
  dashboard: "/dashboard",
  operations_center: "/operations-center",
  customers: "/customers",
  add_customer: "/add-customer",
  customer_detail: "/customer-detail",
  sites_OandM: "/sites-o&m",
  sites_project: "/sites-project",
  add_site: "/add-site",
  site_detail: "/site-detail",
  budget_requests: "/budget-requests",
  create_budget_request: "/create-budget-request",
  budget_logs: "/budget-logs",
  expense_head: "/expense-head",
  shifts: "/shifts",
  add_Shift: "/add-Shift",
  employee_onboard: "/employee-onboard",
  add_employee_onboard: "/add_employee-onboard",
  employee_detail: "/employee-detail",
  my_leave: "/my-leave",
  leave_request: "/leave-request",
  team_leave: "/team-leave",
  leave_detail: "/leave-detail",
  attendance_user: "/attendance-user",
  my_Ar: "/my-attendance-regularization",
  team_Ar: "/team-attendance-regularization",
  ar_request: "/attendance-regularization-request",
  ar_request_detail: "/ar-detail",
  od_request: "/outdoor-duty-request",
  od_request_detail: "/od-request-detail",
  my_od: "/my-od",
  team_od: "/team-od",
  view_od_request: "/view-od-request/:id",
  wfh_request: "/wfh-request",
  wfh_request_detail: "/wfh-request-detail",
  my_wfh: "/my-wfh",
  team_wfh: "/team-wfh",
  add_wfh_request: "/add-wfh-request",
  attendance_admin: "/attendance",
  extra_work: "/extra-work",
  team_attendance: "/team-attendance",
  add_leave_setting: "/add-leave-setting",
  leave_setting: "/leave-setting",
  holiday: "/holiday",
  office_location: "/office",
  add_office: "/add-office",
  company: "/company",
  add_company: "/add-company",
  company_detail: "/company-detail",
  add_Od_request: "/add-od-request",
  assets: "/assets",
  profile: "/profile",
  update_profile: "/update-profile",
  purchase: "/purchase",
  create_purchase: "/create-purchase",
  stock: "/stock",
  stock_detail: "/stock-detail",
  stock_out: "/stock-out",
  stock_out_detail: "/stock-out-detail",
  create_stock_in: "/create-stock-in",
  create_stock_out: "/create-stock-out",
  material_request_admin: "/material-request-admin",
  service_request_admin: "/service-request-admin",
  material_request_user: "/material-request-user",
  service_request_user: "/service-request-user",
  create_material_request: "/create-Material-request",
  create_service_request: "/create-service-request",
  material_request_detail: "/material-request-detail",
  purchase_request_detail: "/purchase-request-detail",
  service_request_detail: "/service-request-detail",
  machinery: "/machinery",
  add_machinery: "/add-machinery",
  machinery_details: "/machinery-details",
  transfer_assets: "/transfer-assets",
  create_transfer_asset: "/create-transfer-asset",
  transfer_asset_detail: "/transfer-asset-detail",
  item_master: "/item-master",
  payslip: "/pay-slip",
  my_payslip: "/my-pay-slip",
  payslip_site_wise: "/pay-slip-site-wise",
  extra_work_user: "/extra-work-user",
  extra_work_team: "/team-extra-work",
  notifications: "/notifications",
  vendor_list: "/vendor-list",
  add_vendor: "/add-vendor",
  vendor_detail: "/vendor-detail",
  service_type: "/service",
  purchase_order: "/purchase-order",
  purchase_order_detail: "/purchase-order-detail",
  add_supply_voucher: "/add-supply-voucher",
  work_order: "/work-order",
  add_work_order: "/add-work-order",
  work_order_detail: "/work-order-detail",
  invoice: "/invoice",
  invoice_detail: "/invoice-detail",
  tds_ledger: "/tds-ledger",
  tds_detail: "/tds-detail",
  create_invoice: "/create-invoice",
  day_book: "/day-book",
  no_internet: "/nointernet",
  under_development_page: "/under-development-page",
  general_expense_head: "/general-expense-head",
  purchase_request: "/purchase-request",
  create_purchase_request: "/create-purchase-request",
  payment_tickets_all: "/payment-tickets-all",
  payment_ticket_against_po: "/payment-ticket-against-po",
  payment_ticket_general: "/payment-ticket-general",
  payment_ticket_reimbursement: "/payment-ticket-reimbursement",
  create_against_po: "/create-agains-po",
  create_general: "/create-general",
  create_reimbursement: "/create-reimbursement",
  payment_tickets_details: "/payment-tickets-details",
  salary_ticket: "/salary-ticket",
  create_salary_ticket: "/create-salary-ticket",
  salary_ticket_detail: "/salary-ticket-detail",
  debit_note: "/debit-note",
  attendance_summary: "/attendance-summary",
  attendance_summary_details: "/attendance-summary-details",
  logs: "/logs",
  payment_advisory: "/payment-advisory",
  payment_advisory_detail: "/payment-advisory-detail",
  privacy_policy: "/privacy-policy",
  vendor_ledger: "/vendor-ledger",
  vendor_ledger_detail: "/vendor-ledger-detail",
  customer_ledger: "/customer-ledger",
  customer_ledger_detail: "/customer-ledger-detail",
  forbidden_403: "/forbidden-403",
  under_maintainance: "/under-maintainance",
  salary_head: "/salary-head",
  add_salary_head: "/add-salary-head",
  site_salary_head: "/site-salary-head",
  add_site_salary_head: "/add_site_salary_head",
  office_salary_head: "/office_salary_head",
  add_office_salary_head: "/add_office_salary_head",
  grn: "/good-received-notes",
  grn_detail: "/good-received-notes-detail",
  createGrn: "/create-good-received-notes",
  payment_overview: "/payment-overview",
  employee_transfer: "/employee_transfer",
  my_Reimbursement_Form: "/my-reimbursement-form",
  team_Reimbursement_Form: "/team-reimbursement-form",
  create_Reimbursement_Form: "/create-reimbursement-form",
  reimbursement_details: "/reimbursement-details",
  site_salary_config: "/site-salary-config",
  transfer_requests: "/transfer-requests",
  manage_bulk_attendance: "/manage-bulk-attendance",
  user_logs: "/user-logs",
  budget_request_detail: "/budget-request-detail",
  how_to_use: "/how-to-use",
  view_create_salary_details: "/view-create-salary-details",
  task_management: "/task-management",
  site_task_management: typeof window !== "undefined" && window.location.hostname === "localhost" ? "http://localhost:5174/shreenath_site_management/" : "/shreenath_site_management/",
  // office_task_management: "/office-task-management",
};
